import api from 'common/api'
import useSnackbar from 'common/use-snackbar'

export type Target = { hsId: string; targeted: boolean }
export type ToggleTargeted = (targets: Target[]) => Promise<boolean>

export default function useTargetHighschoolsExplore(applyTargets?: (targets: Target[]) => void) {
  const setSnackbarError = useSnackbar('An error occurred while targeting this school. Please try again.')

  const toggleTargeted: ToggleTargeted = (targets) => {
    applyTargets?.(targets)
    return api
      .put('/api/users/targeted', { targets })
      .then(() => true)
      .catch(() => {
        applyTargets?.(targets.map((t) => ({ ...t, targeted: !t.targeted })))
        setSnackbarError()
        return false
      })
  }

  return { toggleTargeted }
}
